/* -------------------------------------------------------------------------- */
/*                                  Packages                                  */
/* -------------------------------------------------------------------------- */
import { navigate } from "gatsby"
import * as React from "react"
import { motion } from "framer-motion"
import { X } from "react-feather"

/* -------------------------------------------------------------------------- */
/*                              Default Component                             */
/* -------------------------------------------------------------------------- */
export default function SavePopup(props) {
  return (
    <motion.div
      initial={props.modalInitial || { opacity: 0 }}
      animate={
        props.modalAnimate || {
          opacity: 1,
        }
      }
      exit={
        props.modalExit || {
          opacity: 0,
          transition: {
            duration: 0.2,
          },
        }
      }
      transition={props.modalTransition || { duration: 0.2 }}
      className="bg-grey-1 flex flex-col gap-[30px] items-center max-w-[660px] [padding:35px_60px] relative rounded-[12px] w-full"
    >
      {/* <button className="absolute right-[18px] top-[18px]">
        <X
          className="stroke-baltic-blue"
          strokeWidth={2}
          onClick={() => props.closePopup()}
        />
      </button> */}
      <h3 className="font-variant-numeric--primary sans text-baltic-blue text-center">
        We've got you saved!
      </h3>
      <p className="font-variant-numeric--primary font-[300] leading-[32px] mb-0 text-[20px] text-center text-grey-6">
        Your form is safe and sound. When you’re ready to finish up, we’ll be
        here ready to continue building your personalized homebuying plan.
      </p>
      {/* Buttons Container */}
      <div className="flex justify-center w-full">
        <button
          className="button button--primary font-bold max-w-[328px] w-full"
          onClick={() => {
            props.closePopup()
            // navigate(
            //   `${props.startPath || "/"}${
            //     window.location.search ? window.location.search : ""
            //   }`,
            // )
          }}
        >
          Close
        </button>
      </div>
    </motion.div>
  )
}
